import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { RunupDataGrid } from '../../runups/data/RunupDataGrid';
import { Loading } from '../../../../../loadbar/Loading';
import { isDataManager } from '../../../../../../role/roleUtils';
import {
  clearPageData as clearPageDataAc,
  getTsunami as getTsunamiAc,
  getRunups as getRunupsAc,
  deleteRunup as deleteRunupAc,
  toggleColumns as toggleColumnsAc,
  sortData as sortDataAc,
} from '../../../../../../redux/tsunamis/event/related-runup/tsunamiRelatedRunupsActions';
import { withUser } from '../../../../../auth/withUser';
import { TsunamiSingleResultGrid } from './TsunamiSingleResultGrid';

class TsunamiRelatedRunupPageUnwrapped extends Component {
  componentDidMount() {
    document.title = 'NCEI Hazard Tsunami Related Runup Results';
    const {
      match: { params: { id } },
      getRunups,
      getTsunami,
      clearPageData,
      history,
    } = this.props;
    clearPageData();
    getRunups({ id, history });
    getTsunami({ id, history });
  }

  componentWillUnmount() {
    const { clearPageData } = this.props;
    clearPageData();
  }

  render() {
    const {
      match: { params: { id } },
      fetched,
      tsunami,
      runups,
      authorities,
      sort,
      sortData,
      visibleColumns,
      toggleColumns,
      deleting,
      deleteRunup,
      getRunups,
      history,
    } = this.props;

    const dataManager = isDataManager(authorities);

    if (!fetched) {
      return (<Loading />);
    }

    return (
      <div className="haz-results-container haz-page-container">
        <div className="haz-info-content">
          <div className="haz-info-content-section">
            <Card>
              <CardBody>
                <CardTitle tag="h1">Tsunami Event</CardTitle>
                <TsunamiSingleResultGrid tsunami={tsunami} dataManager={dataManager} />
              </CardBody>
            </Card>
          </div>
        </div>

        <div className="haz-info-content haz-data-grid-container">
          <div className="haz-info-content-section haz-data-grid-container">
            <Card>
              <CardBody>
                <CardTitle tag="h2">{`Runups - ${runups.size} Results Found`}</CardTitle>
                <RunupDataGrid
                  runups={runups}
                  dataManager={dataManager}
                  sort={sort}
                  sortData={sortData}
                  visibleColumns={visibleColumns}
                  toggleColumns={toggleColumns}
                  searchParams={`Tsunami ID = ${tsunami.get('id')}`}
                  deleting={deleting}
                  deleteRunup={deleteRunup}
                  onDeleteCloseModal={() => getRunups({ id, history })}
                />
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

TsunamiRelatedRunupPageUnwrapped.propTypes = {
  fetched: PropTypes.bool.isRequired,
  deleting: PropTypes.bool.isRequired,
  tsunami: ImmutablePropTypes.map.isRequired,
  runups: ImmutablePropTypes.list.isRequired,
  sort: ImmutablePropTypes.list.isRequired,
  visibleColumns: ImmutablePropTypes.list.isRequired,
  sortData: PropTypes.func.isRequired,
  toggleColumns: PropTypes.func.isRequired,
  deleteRunup: PropTypes.func.isRequired,
  getRunups: PropTypes.func.isRequired,
  getTsunami: PropTypes.func.isRequired,
  clearPageData: PropTypes.func.isRequired,
  history: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({ params: PropTypes.shape({ id: PropTypes.string }) }).isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
};

const mapStateToProps = state => ({
  fetched: [
    state.getIn(['tsunamiRelatedRunupsPage', 'fetchedTsunami']),
    state.getIn(['tsunamiRelatedRunupsPage', 'fetchedRunups']),
  ].every(v => v),
  deleting: state.getIn(['tsunamiRelatedRunupsPage', 'deleting']),
  tsunami: state.getIn(['tsunamiRelatedRunupsPage', 'tsunami']),
  runups: state.getIn(['tsunamiRelatedRunupsPage', 'runups']),
  sort: state.getIn(['tsunamiRelatedRunupsPage', 'sort']),
  visibleColumns: state.getIn(['tsunamiRelatedRunupsPage', 'visibleColumns']),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  clearPageData: clearPageDataAc,
  getTsunami: getTsunamiAc,
  getRunups: getRunupsAc,
  deleteRunup: deleteRunupAc,
  toggleColumns: toggleColumnsAc,
  sortData: sortDataAc,
}, dispatch);


export const TsunamiRelatedRunupPage = withUser(connect(mapStateToProps, mapDispatchToProps)(TsunamiRelatedRunupPageUnwrapped));
